import React, { useState, useCallback, useRef } from 'react';

const Cell = ({ value, isRevealed, isFlagged, onClick, onRightClick, gameOver }) => {
  const isMine = value === -1;
  let cellContent = '';
  const [isLongPress, setIsLongPress] = useState(false);
  const longPressTimer = useRef(null);
  const touchStartTime = useRef(0);
  
  if (isRevealed) {
    cellContent = isMine ? '💣' : (value > 0 ? value : '');
  } else if (isFlagged) {
    cellContent = '🚩';
  }

  const cellClass = `cell ${isRevealed ? 'revealed' : ''} ${isRevealed && isMine ? 'mine' : ''} ${isFlagged ? 'flagged' : ''} ${gameOver ? 'game-over' : ''}`;

  const handleTouchStart = useCallback((e) => {
    e.preventDefault();
    touchStartTime.current = Date.now();
    longPressTimer.current = setTimeout(() => {
      setIsLongPress(true);
      onRightClick(e);
    }, 500);
  }, [onRightClick]);

  const handleTouchEnd = useCallback((e) => {
    e.preventDefault();
    clearTimeout(longPressTimer.current);
    const touchDuration = Date.now() - touchStartTime.current;
    if (touchDuration < 500 && !isLongPress) {
      onClick();
    }
    setIsLongPress(false);
  }, [onClick, isLongPress]);

  const handleMouseDown = useCallback((e) => {
    if (e.button === 2) {
      e.preventDefault();
      onRightClick(e);
    }
  }, [onRightClick]);

  const handleClick = useCallback((e) => {
    if (e.button === 0) {
      onClick();
    }
  }, [onClick]);

  return (
    <button 
      className={cellClass} 
      onClick={handleClick}
      onContextMenu={(e) => e.preventDefault()}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={() => {
        clearTimeout(longPressTimer.current);
        setIsLongPress(false);
      }}
      data-value={isRevealed && !isMine ? value : ''}
    >
      {cellContent}
    </button>
  );
};

export default Cell;